export default __webpack_public_path__ + "static/media/avatar.a6143582.png";